import React from 'react';
import { Modal, ModalContent, ModalTitle, ModalText, CloseButton, ModalButton, FieldsList, FieldItem } from './styles';
import { useTranslation } from "contexts/Safra/TranslationContext";

export default function ValidationModal({ isOpen, onClose, missingFields }) {
    const { t } = useTranslation();
    if (!isOpen) return null;

    return (
        <Modal>
            <ModalContent>
                <CloseButton onClick={onClose}>×</CloseButton>
                <ModalTitle>{t('safra.components.validation_modal.title')}</ModalTitle>
                <ModalText>{t('safra.components.validation_modal.text')}</ModalText>
                
                <FieldsList>
                    {missingFields.map((field, index) => (
                        <FieldItem key={index}>• {field}</FieldItem>
                    ))}
                </FieldsList>

                <ModalButton onClick={onClose}>{t('safra.common.close')}</ModalButton>
            </ModalContent>
        </Modal>
    );
}
